import React from 'react';
import { Drawer, Typography } from '@mui/material';

import styled from 'styled-components';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useDrawer } from '../../providers/DrawerProvider';
import { FormRegister } from './FormRegister';
import { FormLogin } from './FormLogin';
import { FormForgotPass } from './FormForgotPass';
import { FormRecoverPass } from './FormRecoverPass';

const CustomDrawer = styled(Drawer)`
  .MuiDrawer-paperAnchorRight {
    background: var(--white) !important;
  }

  .drawerContainer {
    max-width: 720px;
    width: 100vw;
    min-height: 100%;

    header {
      background-color: var(--tertiary);
      padding: 1rem;

      display: flex;
      gap: 0.5rem;
      align-items: center;

      svg {
        cursor: pointer;
      }
    }
  }
`;

export const DrawerForms = () => {
  const { openDrawer, setOpenDrawer, formPanel, setFormPanel } = useDrawer();

  const closeDrawer = () => {
    setOpenDrawer(false);
    setTimeout(() => {
      setFormPanel("register");
    }, 500);
  }

  return (
    <CustomDrawer anchor="right" open={openDrawer} onClose={ closeDrawer }>
      <div className='drawerContainer'>
        <header>
          <ArrowBackIcon onClick={ closeDrawer } className='white--text' />
          <Typography component="span" variant="body1" className='white--text'>
            {formPanel === 'register' && "Cadastre-se agora"}
            {formPanel === 'login' && "Entre com sua conta"}
            {formPanel === 'forgotPassword' && "Lembrar minha senha"}
            {formPanel === 'recoverPassword' && "Redefinir senha"}
          </Typography>
        </header>
        <section>
          {formPanel === 'register' && <FormRegister /> }
          {formPanel === 'login' && <FormLogin /> }
          {formPanel === 'forgotPassword' && <FormForgotPass /> }
          {formPanel === 'recoverPassword' && <FormRecoverPass /> }
        </section>
      </div>
    </CustomDrawer>
  )
}
